import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const pwpFcSeriesMaker = ({
  data,
  name,
  color,
  fixedValue,
}: {
  data: [
    number,
    (
      | NonNullable<
          NonNullable<routes.Values.Response['points']>[string]['values']['soilVwc']
        >[number]['timeseries'][number]['value']
      | null
    ),
  ][]
  name: string
  color: string
  fixedValue: number
}) => {
  if (!data || data.length === 0) {
    return {
      name,
      data: [],
      type: 'line',
      lineWidth: 2,
      color,
    }
  }

  return {
    name,
    id: name,
    data: data.map(([timestamp, value]) => {
      if (typeof value !== 'number') {
        return [timestamp, null]
      }

      return [timestamp, Number(fixedValue.toFixed(4))]
    }),
    type: 'line',
    lineWidth: 2,
    color,
    tooltip: {
      valueSuffix: unitConverter.soilVwc().suffix(),
      valueDecimals: unitConverter.soilVwc().defaultNumberOfDecimalPlaces(),
    },
  }
}
